var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXtwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7663 1.79416H17.479L11.5523 8.56859L18.525 17.7852H13.0657L8.7902 12.1946L3.89698 17.7852H1.18278L7.5223 10.539L0.833374 1.7949H6.43131L10.2962 6.90484L14.7663 1.79416ZM13.8146 16.162H15.3177L5.61455 3.3326H4.00166L13.8146 16.162Z",
    fill: "#7950F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtwitterIcon);
export default __webpack_public_path__ + "static/media/xtwitter-icon.3fa1a25b725f60b74e05b0f319c2fb3d.svg";
export { ForwardRef as ReactComponent };